import React, { useMemo } from 'react';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import { FallbackImage, CheckboxTable } from 'components';
import { UserService } from 'services';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { TimeIcon, CloseIcon, ContactVideoCallIcon, ContactCallIcon, ContactMessageIcon, CheckWhiteIcon } from 'assets/icons';

const phonecodes = [
  { id: 1, name: '0412' },
  { id: 2, name: '0422' },
  { id: 3, name: '0414' },
  { id: 4, name: '0424' },
  { id: 5, name: '0416' },
  { id: 6, name: '0426' },
]

interface Props {
  item?: any
  onClose?: any
  onApprove?: (item: any) => void
  onReject?: (item: any) => void
}

const contact_methods = [
  { id: 1, icon: ContactVideoCallIcon, name: 'Video llamada' },
  { id: 2, icon: ContactCallIcon, name: 'Llamada telefónica' },
  { id: 3, icon: ContactMessageIcon, name: 'Mensaje de texto' },
];

const TAB = {
  DATA: 1,
  PRODUCTS: 2,
}

interface StateI {
  tab: number
  user: any
}

class ModalViewAffiliate extends React.Component<Props> {

  state: StateI = {
    tab: TAB.DATA,
    user: null,
  }

  componentDidMount() {
    this.getInfo();
  }

  getInfo = async () => {
    try {
      const user: any = await UserService.admin.find({ id: this.props.item?.id });

      if (user?.consultation) {
        const methods = String(user?.consultation?.contact_methods).replace(/\[|\]/g, '').split(',');
        user.consultation.contact_methods = methods;
      }

      if (user?.contact_person_phone_code_id) {
        user.contact_person_phone_code = phonecodes.find(x => x.id === user?.contact_person_phone_code_id);
      }

      this.setState({ user });

    } catch (error) {
      console.log(error);
    }
  }

  setTab = (tab: number) => {
    this.setState({ tab });
  }

  render() {

    const { tab, user } = this.state;
    const isUnderReview = user?.verification === Constants.USER.VERIFICATION.PENDING;
    const isMedic = user?.affiliate_type === Constants.AFFILIATE_TYPES.MEDIC;
    const isClinic = user?.affiliate_type === Constants.AFFILIATE_TYPES.CLINIC;
    const isBusiness = user?.affiliate_type === Constants.AFFILIATE_TYPES.BUSINESS_SERVICE_OR_ADVERTISER;

    if (!user) return (
      <Fallback user={this.props.item} onClose={this.props.onClose} />
    );

    return (
      <div id="modal-create-doctor" className="view">
        <div className="header">
          <p className="title">{ this.props.item?.name }</p>
          <button className="close" onClick={this.props.onClose}>
            <img src={CloseIcon} alt="Cerrar" />
          </button>
        </div>
        <p className="section-title">Fecha de registro: { moment(this.props.item?.created_at).format('DD-MM-YYYY') }</p>

        <div className="tabs">
          <button data-active={String(tab === TAB.DATA)} onClick={() => this.setTab(TAB.DATA)}>
            Datos
          </button>
          <button data-active={String(tab === TAB.PRODUCTS)} onClick={() => this.setTab(TAB.PRODUCTS)}>
            Productos
          </button>
        </div>

        {tab === TAB.DATA && (
          <div className="row">
            <div className="col-md-4">
              <p className="label">CI/RIF</p>
              <p>{ user?.document_type?.name }{ user?.document }</p>
            </div>
            <div className="col-md-4">
              <p className="label">Teléfono</p>
              <p>{ user?.phonecode?.name }-{ user?.phone }</p>
            </div>
            <div className="col-md-4">
              <p className="label">Correo</p>
              <p>{ user?.email }</p>
            </div>
            <div className="col-md-4">
              <p className="label">Ciudad</p>
              <p>{ user?.city?.name }</p>
            </div>
            <div className="col-md-4">
              <p className="label">Estado</p>
              <p>{ user?.state?.name }</p>
            </div>
            <div className="col-md-4">
              <p className="label">Tipo de afiliado</p>
              <p>{ user?.affiliate_type_txt }</p>
            </div>
            <div className="col-md-12">
              <p className="label">Dirección</p>
              <p>{ user?.address }</p>
            </div>

            <div className="col-md-12">
              <hr />
            </div>

            {(isMedic || isClinic) && (
              <>
              <div className="col-md-12">
                <p className="section-title">Datos bancarios</p>
              </div>
              <div className="col-md-4">
                <p className="label" title={user?.bank_account?.bank?.name}>{ user?.bank_account?.bank?.name }</p>
                <p>{ user?.bank_account?.number }</p>
              </div>
              <div className="col-md-4">
                <p className="label">Cédula</p>
                <p>{ user?.bank_account?.document_format }</p>
              </div>
              <div className="col-md-4">
                <p className="label">Teléfono</p>
                <p>{ user?.bank_account?.phone_format }</p>
              </div>

              <div className="col-md-12">
                <hr />
              </div>
              </>
            )}

            {(isBusiness || isClinic) && (
              <>
                <div className="col-md-12">
                  <p className="section-title">Datos de persona de contacto</p>
                </div>
                <div className="col-md-4">
                  <p className="label">Nombre</p>
                  <p>{ user?.contact_person_name }</p>
                </div>
                <div className="col-md-4">
                  <p className="label">Documento</p>
                  <p>{ user?.contact_person_document }</p>
                </div>
                <div className="col-md-4">
                  <p className="label">Teléfono</p>
                  <p>{user?.contact_person_phone_code?.name}-{ user?.contact_person_phone }</p>
                </div>
                <div className="col-md-4">
                  <p className="label">Correo</p>
                  <p>{ user?.contact_person_email }</p>
                </div>

                <div className="col-md-12">
                  <hr />
                </div>
              </>
            )}

            <div className="col-md-12">
              <p className="section-title">Datos profesionales</p>
            </div>
            {isMedic && (
              <div className="col-md-12 files">
                <FileCard label="Título universitario" file={user?.professional_data?.university_title} />
                <FileCard label="Carnet de Colegio de Médicos Veterinarios" file={user?.professional_data?.medical_carnet} />
                <FileCard label="Registro en el INSAI" file={user?.professional_data?.insai} />
                <FileCard label="Registro en el MPPS" file={user?.professional_data?.mpps} />
              </div>
            )}
            <div className="col-md-12">
              <p className="label">Especialidad</p>
              <div className="speciality-list">
                { user?.user_specialties?.map((i: any) => (
                  <span key={i.name}>{ i.name }</span>
                )) }
              </div>
            </div>
            {isMedic && (
              <>
                <div className="col-md-6">
                  <p className="label">Años de experiencia</p>
                  <p>{ user?.professional_data?.years }</p>
                </div>
                <div className="col-md-6">
                  <p className="label">Número de Registro en el Colegio de Médicos Veterinarios</p>
                  <p>{ user?.professional_data?.medical_number }</p>
                </div>
              </>
            )}
            {(isMedic || isClinic) && (
              <div className="col-md-6">
                <p className="label">Idiomas</p>
                <p>{ String(user?.languages?.map((i: any) => i.language_txt).join(', ')) }</p>
              </div>
            )}

            <div className="col-md-12">
              <hr />
            </div>

            <div className="col-md-12">
              <p className="section-title">Áreas de especialización</p>
            </div>
            {(isMedic || isClinic) && (
              <>
                <div className="col-md-12 areas">
                  {user?.areas_specialization?.map((i: any, index: number) => (
                    <div key={index} className="check-item">
                      <CheckboxTable active />
                      <p>{ i.area_txt }</p>
                    </div>
                  ))}
                </div>
                <div className="col-md-12">
                  <p className="label">Animales</p>
                  <div className="speciality-list">
                    {user?.affiliate_animals?.map((i: any, index: number) => (
                      <span key={index}>{ i.type_txt }</span>
                    ))}
                  </div>
                </div>
                <div className="col-md-12">
                  <p className="label">Servicios que ofrece</p>
                  <div className="speciality-list">
                    {user?.user_services?.map((i: any, index: number) => (
                      <span key={index}>{ i.type_txt }</span>
                    ))}
                  </div>
                </div>
              </>
            )}
            <div className="col-md-12">
              <p className="label">Categorías</p>
              <div className="category-list">
                {user?.categories?.map((i: any, index: number) => (
                  <div key={index}>
                    <FallbackImage
                      src={i?.category?.image}
                      placeholder={WhiteImage}
                      className="category-image"
                      placeholderClassName="category-image"
                    />
                    <span>{ i?.category?.name }</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <p className="label">Veterinarios</p>
              <div className="speciality-list">
                {user?.affiliate_veterinarians?.map((i: any) => (
                  <span key={i.id}>{ i.name }</span>
                ))}
              </div>
            </div>

            <div className="col-md-12">
              <hr />
            </div>

            <div className="col-md-12">
              <p className="section-title">Información de la consulta</p>
            </div>
            <div className="col-md-12 row">
              <div className="col-md-4">
                <p className="label">Horario de atención</p>
                <div className="time">
                  <img className="time" src={TimeIcon} alt="Horario de atención" />
                  <span>{ moment(Globals.parseTime(user?.consultation?.init_hour), 'HH:mm').format('hh:mm A') } - { moment(Globals.parseTime(user?.consultation?.end_hour), 'HH:mm').format('hh:mm A') }</span>
                </div>
              </div>

              <div className="col-md-4">
                <p className="label">Días</p>
                <p>{ user?.consultation?.days_txt }</p>
              </div>

              <div className="col-md-4">
                <p className="label">Costo de consulta</p>
                <p className="bold">${ Globals.formatMiles(user?.consultation?.teleconsultation_rate?.amount, true, '').replace(' ','') }</p>
              </div>
              <div className="col-md-12 services">
                {!!user?.consultation?.home_service && (
                  <div className="check-item">
                    <CheckboxTable active />
                    <p>Disponible para consultas a domicilio</p>
                  </div>
                )}
                {!!user?.consultation?.emergency_service && (
                  <div className="check-item">
                    <CheckboxTable active />
                    <p>Presta servicio de emergencia 24 horas</p>
                  </div>
                )}
                {!!user?.consultation?.delivery_service && (
                  <div className="check-item">
                    <CheckboxTable active />
                    <p>Cuenta con servicio de delivery</p>
                  </div>
                )}
              </div>

              <div className="col-md-12">
                <label className="contact-method-title">Método de contacto</label>
                <div className="contact-method-list">
                  {contact_methods.filter(cm => Array.from(user?.consultation?.contact_methods || [])?.includes(String(cm.id))).map((cm, cmIdx) => (
                    <div
                      key={cmIdx}
                      className="contact-method"
                      data-selected="false"
                    >
                      <img src={cm.icon} alt="Método de contacto"  />
                      <span>{ cm.name }</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <hr />
            </div>

            <div className="col-md-12">
              <p className="section-title">Información de consulta</p>
            </div>

            <div className="col-md-4 container-image">
              <FallbackImage
                src={user?.photo}
                placeholder={WhiteImage}
                className="selected-image"
                placeholderClassName="selected-image inactive"
                alt="Logo"
              />
              <p className="photo-title">Imagen publicitaria</p>
            </div>

            <div className="col-md-8">
              <p className="label">Descripción de su empresa</p>
              <p>{ user?.description }</p>

              <div className="seller-code">
                <span>Código del vendedor</span>
                <span>{ user?.seller?.code }</span>
              </div>
            </div>

            {isUnderReview && (
              <div className="actions">
                <button className="btn-success" onClick={this.props.onApprove}>
                  <img src={CheckWhiteIcon} alt="Aprobar" />
                  <span>Aprobar</span>
                </button>

                <button className="btn-danger" onClick={this.props.onReject}>
                  <img src={CloseIcon} alt="Rechazar" />
                  <span>Rechazar</span>
                </button>
              </div>
            )}
          </div>
        )}

        {tab === TAB.PRODUCTS && (
          <div className="products">
            {user?.products?.map((i: any, index: number) => (
              <div key={index} className="product">
                <div className="product-wrapper">
                  <FallbackImage
                    src={i?.image}
                    placeholder={WhiteImage}
                    className="product-image"
                    placeholderClassName="product-image"
                  />
                </div>
                <p className="name">{ i?.name }</p>
              </div>
            ))}

            {!user?.products?.length && (
              <p className="empty">No tiene productos</p>
            )}
          </div>
        )}
      </div>
    )
  }
}

const Fallback = ({ user, onClose }: any) => {
  return (
    <div id="modal-create-doctor" className="view">
      <div className="header">
        <p className="title">{ user?.name }</p>
        <button className="close" onClick={onClose}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </div>
      <p className="section-title">Fecha de registro: { moment(user?.created_at).format('DD-MM-YYYY') }</p>

      <div className="row">
        <div className="col-md-12 spinner">
          <Spinner animation="border" />
        </div>
      </div>
    </div>
  )
}

interface FileCardProps {
  label: string
  file?: string
}

const FileCard = ({ label, file }: FileCardProps) => {
  const fileName = useMemo(() => {
    if (!file) return 'No registrado';
    const length = file.length;
    return '...' + String(file).substring(length - 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="file">
      <label>{ label }</label>
      <div className="file-card">
        {!!file && (
          <div className="photo-wrapper">
            <FallbackImage
              src={file}
              placeholder={WhiteImage}
              className="file-image"
              placeholderClassName="file-image"
              alt={fileName}
            />
          </div>
        )}
        <label>{ fileName }</label>
      </div>
    </div>
  )
}

export default ModalViewAffiliate;

// v0